import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { RegisterForm } from "@/components/forms/RegisterForm";
import { useUser } from "@/hooks/useUser";
import { PATH_LABEL_KEYS, PATHS } from "@/config/paths";
import { useMobile } from "@/providers/mobileProvider";
import { useMobileNavbar } from "@/providers/mobileNavbarProvider";
import { NotFound } from "@/not-found";
import { GlobalError } from "@/global-error";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

export const Route = createFileRoute("/register/")({
  component: RegisterPage,
  notFoundComponent: NotFound,
  errorComponent: GlobalError,
});

function RegisterPage() {
  const { isMobile } = useMobile();
  const { isAuthenticated } = useUser();
  const { setMobileNavbar } = useMobileNavbar();
  const router = useRouter();
  const { t } = useTranslation();

  const goBack = () => {
    router.history.back();
  };

  // Set up navbar configuration
  useEffect(() => {
    if (isMobile) {
      setMobileNavbar({
        title: t(PATH_LABEL_KEYS[PATHS.REGISTER]),
        showBackButton: true,
      });
    }
  }, [isMobile, setMobileNavbar]);

  if (isAuthenticated || !isMobile) {
    router.navigate({ to: PATHS.DASHBOARD });
  }

  return (
    <Card className="col-span-12 sm:col-span-10 sm:col-start-2 md:col-span-8 md:col-start-3 lg:col-span-6 lg:col-start-4">
      <CardHeader>
        <CardTitle asHeading>
          <div className="text-lg font-semibold leading-none tracking-tight flex items-center gap-2">
            <Button variant="ghost" size="icon" className="size-8" onClick={() => goBack?.()}>
              <ArrowLeft className="text-foreground" />
            </Button>
            {t("auth.register.page_title")}
          </div>
        </CardTitle>
        <CardDescription>{t("auth.register.page_description")}</CardDescription>
      </CardHeader>

      <CardContent className="pt-0">
        <RegisterForm />
      </CardContent>
    </Card>
  );
}
